/**
 * The voice and the faces of the kiosk role (an operator or a replay has neither: they must never
 * open the session's voice). MuseTalk needs the voice (its clock) and `?avatar` on (the default);
 * the three.js head needs `?bg3d=1`. The particle orb is the platform's own (avatar/face.ts).
 */
import { createElement } from 'react';
import type { Flags } from '@platform/core/flags';
import type { Kiosk } from '@platform/core/kiosk';
import { LowpolyAvatar } from '@platform/avatar/LowpolyAvatar';
import { MuseTalkAvatar } from '@platform/avatar/MuseTalkAvatar';
import type { FaceKind, FaceRenderer } from '@platform/avatar/face';
import type { VoiceController } from '@platform/voice/controller';
import { createVoice } from '@platform/voice/create-voice';

export function createKioskVoice(flags: Flags, kiosk: Kiosk): VoiceController {
  return createVoice({ sessionId: kiosk.sessionId, kiosk, aec: flags.aec, aecPinned: flags.aecFromUrl, keepOpen: flags.speak });
}

export function avatarFor(flags: Flags, voice: VoiceController | null): FaceRenderer | null {
  const has = (kind: FaceKind) => (kind === 'musetalk' ? flags.avatar && voice !== null : kind === 'lowpoly' && flags.lowpoly);
  if (!has('musetalk') && !has('lowpoly')) return null;
  return {
    has,
    Render: function ExternalFace({ kind, onLive }) {
      if (kind === 'lowpoly' && has('lowpoly')) return createElement(LowpolyAvatar, { onLive });
      if (kind === 'musetalk' && voice && has('musetalk')) return createElement(MuseTalkAvatar, { bridge: voice.avatar, plateId: flags.avatarPlate, onLive });
      return null;
    },
  };
}
